// 模块数据
export const state = {
  // 目录数据
  menus: null,
  // tab导航条索引
  tabIndex: 0,
  // 头部高度
  headerHeight: 0,
  // 视频1
  video1: '',
  // 视频2
  video2: '',
  // 视频3
  video3: '',
  // 视频4
  video4: '',
}
// 公开数据
export const getters = {
  contentHeight: state => document.getElementById('app').clientHeight - state.headerHeight
}



// WEBPACK FOOTER //
// ./src/store/data.js